import warmPackages from "./warm-packages.js?raw";

link rel="preconnect" href="https://registry.npmjs.org" crossorigin

html-script -- ${warmPackages};

hash-files/files=[
  {
    path: "index.marko",
    content:
      "<let/count=0>\n<button onClick() { count++ }>\n  ${count}\n</button>\n",
  },
]

playground files:=files
